export default {
  "Tabs": "_Tabs_1qky6_1",
  "Tab": "_Tab_1qky6_1"
};import "ni:sha-256;WpzgUEWyivT7-jqEmuRiUGThJjudNC6hg41khAOOWxk";